import { forwardRef, type InputHTMLAttributes } from "react";

import styles from "./Input.module.css";
import { cx } from "../lib/cx";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...rest }, ref) => (
    <input className={cx(styles.input, className)} ref={ref} {...rest} />
  ),
);

Input.displayName = "Input";
